import React from 'react'

export const SkipLink: React.FC = () => {
  return (
    <a
      href="#main-content"
      className="skip-link sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:px-4 focus:py-2 focus:bg-kylix-primary focus:text-white focus:rounded focus:font-semibold focus:outline-none focus:ring-2 focus:ring-kylix-secondary"
    >
      Pular para o conteúdo principal
    </a>
  )
}